// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperFinderUpsell-cls1_SJr","cls2":"PaperFinderUpsell-cls2_MMa PaperFinderUpsell-cls1_SJr"};